import React from "react"
import PropTypes from "prop-types"
import { semantic } from '@lexody/design-tokens'

class NotificationItem extends React.Component {
  render() {
    return(
      <div onClick={() => this.props.onClick(this.props.notification.id)} className="wrapper_form_dark form_section" style={{border: `2px solid ${semantic.primary.text.label}`, marginTop: 10, cursor: 'pointer'}}>
        <img
          src={this.props.closeIcon}
          style={{
            position: 'absolute',
            right: 0,
            marginTop: -10,
            paddingRight: 5,
            height: 20,
          }}/>
        <h2 className="heading_standard">{this.props.notification.notes}</h2>
      </div>
    )
  }

}
export default NotificationItem;
